<template>
  <PTCLink
    v-if="pdfFile?.asset?._ref"
    :class="{
      'inline-flex items-center gap-2': true,
    }"
    :target="target"
    :to="src"
  >
    <slot />
  </PTCLink>
  <slot v-else />
</template>

<script setup lang="ts">
import type { PdfLink } from '~/sanity/types';

const props = defineProps<PdfLink>();

const target = '_blank';

const getSrc = (): string => {
  const pdfRef = props.pdfFile?.asset?._ref as string;
  if (!pdfRef) {
    console.warn('No PDF file provided to PDFLink', JSON.stringify(props));
    return '#';
  }
  const bits = pdfRef.split('-');
  if (bits.length < 3) {
    console.warn('Invalid PDF file reference:', pdfRef);
    return '#';
  }

  const fileName = bits[1];
  const fileExtension = bits[2];
  return `/cdn-files/${fileName}.${fileExtension}`;
};
const src = getSrc();
</script>

<style scoped></style>
